import _ from 'lodash';
import React from 'react';

import { Grid, Segment, Button } from 'semantic-ui-react';

import { Position } from './index';
import API from '../services/api';

class Statistics extends React.Component {
	constructor (props) {
		super(props);

		this.state = {
			symbol: props.symbol,
			users: [],
			userIndx: 0,
			screen: props.screen
		};
	}

	componentDidMount () {
		const { symbol } = this.state;

		if (symbol) {
			API.Position.users(symbol)
				.then((users) => {
					this.setState({
						users,
					});
				})
				.catch(err => {
					console.error(err);
				});
		}
	}

	changeUser (indx) {
		const {
			users,
		} = this.state;
		this.setState({
			userIndx: indx
		});

	}

	render () {
		const {
			symbol,
			users,
			userIndx,
			screen
		} = this.state;

		const usersWithPosition = [];
		const usersAmount = users.length;

		_.forEach(users, ({ trade: { position } }, indx) => {
			if (position && position.side !== '' && position.side !== 'None') {
				usersWithPosition.push(users[indx]);
			}
		});

		const minAvg = _.get(_.minBy(usersWithPosition, ({ trade: { position } }) => (position.avgPrice)), 'trade.position.avgPrice');
		const maxAvg = _.get(_.maxBy(usersWithPosition, ({ trade: { position } }) => (position.avgPrice)), 'trade.position.avgPrice');
		const meanAvg = _.meanBy(usersWithPosition, ({ trade: { position } }) => Number(position.avgPrice || 0));

		return (
			<Segment>
				<Grid centered divided="vertically">
					<Grid.Row columns={2}>
						<Grid.Column>Всего: {usersAmount}</Grid.Column>
						<Grid.Column>Открыто: {usersWithPosition.length}</Grid.Column>
					</Grid.Row>
					<Grid.Row columns={3}>
						<Grid.Column>Мин.: {minAvg}</Grid.Column>
						<Grid.Column>Сред.: {meanAvg}</Grid.Column>
						<Grid.Column>Макс.:{maxAvg}</Grid.Column>
					</Grid.Row>
					<Grid.Row columns={1}>
						<Grid.Column>
							{_.map(users, (user, indx) => <Button className={(userIndx === indx ? "blue" : (_.get(user, 'trade.position.side', "") === "Buy" ? "green" : (_.get(user, 'trade.position.side', "") === "Sell" ? "red" : "")))} key={`${indx}_user_button`} compact onClick={() => this.changeUser(indx)}>
								{_.get(user, 'member.user.username', user.id)}
							</Button>)}
						</Grid.Column>
					</Grid.Row>
					{((!!symbol && users && users[userIndx]) ? <Grid.Row columns={1}>
						<Grid.Column>
							<Position screen={screen} user={userIndx} position={_.get(users[userIndx], 'trade.position', null)} orders={_.get(users[userIndx], 'trade.orders', null)} symbol={symbol}/>
						</Grid.Column>
					</Grid.Row> : <></>)}
				</Grid>
			</Segment>
		);
	}
}

export default Statistics;
